export default __webpack_public_path__ + "static/media/fart.47747695.mp3";